import moment from "moment-timezone";

function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateRandomPastDates(count: number): string[] {
  const today = moment();
  const pastDates: moment.Moment[] = [];

  for (let i = 0; i < count; i++) {
    const randomDaysAgo = getRandomInt(1, 20);
    const date = today.clone().subtract(randomDaysAgo, "days");
    pastDates.push(date);
  }

  // Sort dates in ascending order (earliest to latest)
  pastDates.sort((a, b) => a.diff(b));

  return pastDates.map((date) => date.format("MMMM D"));
}
